'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
function $ct_Lpresto_SiteTables$GroupStatus__T__T__($thiz, legend, tip) {
  $thiz.K2 = legend;
  $thiz.D8 = tip;
  return $thiz;
}
export { $ct_Lpresto_SiteTables$GroupStatus__T__T__ as $ct_Lpresto_SiteTables$GroupStatus__T__T__ };
/** @constructor */
function $c_Lpresto_SiteTables$GroupStatus() {
  this.K2 = null;
  this.D8 = null;
}
export { $c_Lpresto_SiteTables$GroupStatus as $c_Lpresto_SiteTables$GroupStatus };
$p = $c_Lpresto_SiteTables$GroupStatus.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_SiteTables$GroupStatus;
/** @constructor */
function $h_Lpresto_SiteTables$GroupStatus() {
}
export { $h_Lpresto_SiteTables$GroupStatus as $h_Lpresto_SiteTables$GroupStatus };
$h_Lpresto_SiteTables$GroupStatus.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
var $d_Lpresto_SiteTables$GroupStatus = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i(0, "presto.SiteTables$GroupStatus", ({
  d7: 1,
  b: 1,
  c: 1,
  a: 1,
  q: 1
}));
export { $d_Lpresto_SiteTables$GroupStatus as $d_Lpresto_SiteTables$GroupStatus };
//# sourceMappingURL=presto.-Site-Tables$-Group-Status.js.map
